import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Select,
  message,
  Checkbox,
  Switch,
  Upload,
  Space,
  TimePicker,
  Button,
} from "antd";
import styled from "@emotion/styled";
import moment from "moment";
import {
  NON_EMPTY_REGEX,
  EMAIL_REGEX,
  countryList,
  Greetings,
  AwardList,
  STATUS_CODE,
  CountryData,
} from "common/Constants";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isEmpty } from "lodash";
import { CALL_API, CALL_API_EMAIL } from "common/API";

const StyledButton = styled(Button)`
  background-color: #2d53da !important;
  border-radius: 5px;
  color: #fff !important;
  width: 100px;

  &:hover {
    color: #fff !important;
  }

  &:focus {
    color: #fff !important;
  }
`;

const StyleRow = styled(Row)`
  padding: 10px;
  box-shadow: 0px 3px 6px #00000015;
  .ant-form-item-label {
    text-align: left;
  }
  .ant-picker {
    width: 100% !important;
  }
  .ant-upload.ant-upload-select {
    width: 100% !important;
    color: #397ff4 !important;
    .ant-btn > span {
      display: inline-block;
      color: #397ff4;
    }
    button,
    html [type="button"],
    [type="reset"],
    [type="submit"] {
      background: #f2f2f2;
    }
    .ant-upload-list-picture .ant-upload-list-item,
    .ant-upload-list-picture-card .ant-upload-list-item {
      height: 40px;
    }
    .ant-upload-list-text .ant-upload-list-item-name,
    .ant-upload-list-picture .ant-upload-list-item-name {
      color: #397ff4;
    }
  }
`;

function PersonalForm({
  setStep,
  setFormValues,
  formValues,
  form,
  countrycode,
  setcountrycode,
}) {
  const { Option } = Select;
  const containerRef = useRef(null);

  const [emailsList, setEmailList] = useState([]);

  const getEmailList = async () => {
    const { code, response } = await CALL_API_EMAIL(
      `add-users/email-list`,
      "get",
    );
    if (code === STATUS_CODE.SUCCESS) setEmailList(response);
  };

  const validateEmployeeId = (rule, value) => {
    if (value && emailsList.includes(value)) {
      return Promise.reject("User ID already exist");
    }
    return Promise.resolve();
  };

  const onFinish = (values) => {
    const currentFormValues = form.getFieldValue();
    setFormValues((prevValues) => ({
      ...prevValues,
      ...currentFormValues,
    }));
    setStep(1);
    // Handle API calls or state updates here
  };

  const getMaxLengthByCountry = (countryName) => {
    const country = CountryData.find(
      (country) => country.name.toLowerCase() === countryName.toLowerCase(),
    );
    return country ? country.phone_length : null;
  };

  const getCountryCodeByName = (countryName) => {
    const country = CountryData.find(
      (country) => country.name.toLowerCase() === countryName.toLowerCase(),
    );
    return country ? country.code : null;
  };

  useEffect(() => {
    getEmailList();
    if (!isEmpty(formValues)) {
      form.setFieldsValue(formValues);
    }
  }, [formValues]);

  console.log("formvalues--->", formValues);

  return (
    <div>
      <Form
        className=""
        form={form}
        name="addemployeeform"
        layout="vertical"
        initialValues={{
          initial: "",
          firstname: "",
          lastname: "",
          salutation: "",
          user_id: "",
          department_id: "",
          password: "",
          gender: "",
          date_of_birth: "",
          marital_status: "",
          nationality: "",
          address: "",
          phone: "",
          overtime: "",
          start_date: "",
          halfpay: false,
          bandName: "",
          emergencycontactname: "",
          emergencycontactnumber: "",
          employementtype: "",
          bandid: "",
          national_id: "",
          nssf: "",
          reportingmanager: "",
        }}
        onFinish={() => onFinish(1)}
      >
        <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="salutation"
              label="Salutation"
              placeholder="Select Salutation"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Salutation is required",
                },
              ]}
            >
              <Select
                placeholder="Select Salutation"
                getPopupContainer={() => containerRef.current}
              >
                <Option value="Mr.">Mr.</Option>
                <Option value="Dr.">Dr.</Option>
                <Option value="Prof.">Prof.</Option>
                <Option value="Ms.">Ms.</Option>
                <Option value="Mrs.">Mrs.</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="initial"
              label="Initial"
              rules={[
                {
                  required: false,
                  pattern: NON_EMPTY_REGEX,
                  message: "Initial is required",
                },
              ]}
            >
              <Input
                placeholder="Initial"
                maxLength={5}
                onKeyDown={(e) => {
                  const allowedChars = /^[a-zA-Z\s]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="firstname"
              label="First Name"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "First name is required",
                },
              ]}
            >
              <Input
                placeholder="First name"
                maxLength={50}
                onKeyDown={(e) => {
                  const allowedChars = /^[a-zA-Z\s]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="lastname"
              label="Last Name"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Last name is required",
                },
              ]}
            >
              <Input
                placeholder="Last name"
                maxLength={50}
                onKeyDown={(e) => {
                  const allowedChars = /^[a-zA-Z\s]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="user_id"
              label="Email ID"
              rules={[
                {
                  required: true,
                  pattern: EMAIL_REGEX,
                  message: "Email ID is required",
                },
                { validator: validateEmployeeId },
              ]}
            >
              <Input placeholder="Email ID" maxLength={60} />
            </Form.Item>
          </Col>
          {/* <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        required: true,
                        message: "Password is required.",
                      },
                      {
                        validator: (_, value) => {
                          if (!value || value.trim().length === 0) {
                            return Promise.reject("");
                          } else if (value.length < 8 || value.length > 15) {
                            return Promise.reject(
                              "Password should be min 8 to max 15 characters."
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Password"
                      autoComplete="new-password"
                      maxLength={15}
                    />
                  </Form.Item>
                </Col> */}

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              name="gender"
              label="Gender"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Gender is required",
                },
              ]}
            >
              <Select
                placeholder="Select gender"
                getPopupContainer={() => containerRef.current}
              >
                <Option value="male">Male</Option>
                <Option value="female">Female</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label="Date of Birth"
              name="date_of_birth"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Date of birth is required",
                },
              ]}
            >
              <DatePicker
                className="w-100"
                format="DD-MM-YYYY"
                placeholder="Select Date of Birth"
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              name="marital_status"
              label="Marital Status"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Marital Status is required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                getPopupContainer={() => containerRef.current}
              >
                <Option value="single">Single</Option>
                <Option value="married">Married</Option>
                <Option value="widow">Widow</Option>
                <Option value="divorced">Divorced</Option>
              </Select>
            </Form.Item>
          </Col>
          {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                    name="reportingmanager"
                    label="Reporting Manager"
                    rules={[
                      {
                        required: userList?.length !== 0 ? true : false,
                        pattern: NON_EMPTY_REGEX,
                        message: "Marital Status is required",
                      },
                    ]}
                  >
                    <Select
                      className="selectbox mb-2"
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.name ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.name ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.name ?? "").toLowerCase())
                      }
                      placeholder="Select Manager"
                      options={userList?.filter((item)=>item?.userid !== userInfo?.userid)}
                      fieldNames={{
                        label: "fullname",
                        value: "userid",
                      }}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                  </Col> */}

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              name="nationality"
              label="Country"
              rules={[{ required: true, message: "Country is required" }]}
            >
              <Select
                showSearch
                placeholder="Search to Select"
                optionFilterProp="children"
                getPopupContainer={() => containerRef.current}
                onChange={(values) =>
                  setcountrycode(getCountryCodeByName(values))
                }
              >
                {countryList?.map((country, index) => (
                  <Select.Option key={index} value={country} label={country}>
                    {country}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item name="phone" label="Phone Number">
              <PhoneInput
                type="text"
                defaultCountry={countrycode ? countrycode : ""}
                placeholder="Phone number"
                maxLength={
                  form.getFieldValue("nationality")
                    ? Number(
                        getMaxLengthByCountry(
                          form.getFieldValue("nationality"),
                        ),
                      ) + 2
                    : 15
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="emergencycontactname"
              label="Emergency Contact Name"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Emergency Contact Name is required",
                },
              ]}
            >
              <Input
                placeholder="Emergency Contact Name"
                maxLength={15}
                onKeyDown={(e) => {
                  const allowedChars = /^[a-zA-Z\s]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="emergencycontactnumber"
              label="Emergency Contact Number"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Emergency Contact Number is required",
                },
              ]}
            >
              <PhoneInput
                type="text"
                defaultCountry={countrycode ? countrycode : ""}
                placeholder="Emergency Contact Number"
                maxLength={
                  form.getFieldValue("nationality")
                    ? Number(
                        getMaxLengthByCountry(
                          form.getFieldValue("nationality"),
                        ),
                      ) + 2
                    : 15
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item name="nssf" label="NSSF">
              <Input
                placeholder="NSSF"
                maxLength={20}
                onKeyDown={(e) => {
                  const value =
                    /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                  if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item name="national_id" label="National ID">
              <Input
                placeholder="National ID"
                maxLength={20}
                onKeyDown={(e) => {
                  const value =
                    /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                  if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="address"
              label="Address"
              rules={[
                {
                  required: true,
                  message: "Address is required",
                },
              ]}
            >
              <Input
                placeholder="Address"
                maxLength={60}
                onKeyDown={(e) => {
                  const value =
                    /^[0-9,/]$/.test(e.key) || /^[a-zA-Z\s,/]+$/.test(e.key);
                  if (!value && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>

          {/* // Note: need for future */}

          {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label="Band Name"
                    name="bandid"
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: "Please Select",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Band"
                      name="bandid"
                      options={bandList}
                      fieldNames={{
                        label: "bandName",
                        value: "bandId",
                      }}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col> */}
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              name="overtime"
              label="Overtime Eligible"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Overtime Eligible is required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                getPopupContainer={() => containerRef.current}
              >
                <Option value="yes">Yes</Option>
                <Option value="no">No</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label="Start Date"
              name="start_date"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Start Date is required",
                },
              ]}
            >
              <DatePicker
                className="w-100"
                format="DD-MM-YYYY"
                placeholder="Select Start date"
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item name="salary" label=" Salary">
              <Input
                placeholder="Salary"
                type="text"
                maxLength={10}
                onKeyDown={(e) => {
                  const value = /^[0-9]$/?.test(e.key);
                  if (
                    !value &&
                    e.key !== "Backspace" &&
                    e.key !== "Tab" &&
                    /^[0-9]$/
                  ) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              name="employementtype"
              label="Employment Type"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Employment type is required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                getPopupContainer={() => containerRef.current}
                onChange={(values) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    employementtype: values,
                  }));
                }}
              >
                <Option value="Casual">Casual</Option>
                <Option value="Contract">Contract</Option>
                <Option value="Full time">Full time</Option>
                <Option value="Paid Internship">Paid Internship</Option>
                <Option value="Part time">Part time</Option>
                <Option value="Training">Training</Option>
                <Option value="Unpaid Internship">Unpaid Internship</Option>
                <Option value="Probation">Probation </Option>
              </Select>
            </Form.Item>
          </Col>
          {formValues?.employementtype === "Probation" && (
            <>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label="Probation Start Date"
                  name="probationstartdate"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Probation Start Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Probation start date"
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label="Probation End Date"
                  name="probationenddate"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Probation End Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Probation End date"
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          {formValues?.employementtype === "Contract" && (
            <>
              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label="Contract Start Date"
                  name="contractstartdate"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Contract Start Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Contract start date"
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  label="Contract End Date"
                  name="contractenddate"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Contract End Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format="DD-MM-YYYY"
                    placeholder="Select Contract End date"
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>
            </>
          )}

          {/* <Col xs={24} sm={24} md={24}>
                  <Form.Item name="profile" label="Profile Pic">
                    <StyledDropzone {...getRootProps()}>
                      <input {...getInputProps()} disabled />
                      <p>
                        {filename !== "" ? <>{filename}</> : <> choose file</>}
                      </p>
                    </StyledDropzone>
                  </Form.Item>
                </Col> */}
        </StyleRow>
        <div className="text-end">
          {/* <StyledButton type="primary" onClick={() => Reset()}>
                  Reset
                </StyledButton> */}
          <StyledButton type="primary" htmlType="submit">
            Next
          </StyledButton>
        </div>
      </Form>
    </div>
  );
}

export default PersonalForm;
